import React from 'react';
import PropTypes from 'prop-types';

import styles from './CamPlaceholder.module.scss';

const CamPlaceholder = ({ isDown, shouldLoad = false, stillUrl = '' }) => (
  <div
    className={styles.CamPlaceholder}
    style={
      shouldLoad
        ? {
            backgroundImage: `url(${stillUrl})`,
          }
        : {}
    }
  >
    {!isDown && (
      <div className={styles.spinnerContainer}>
        <div className={styles.loading} />
      </div>
    )}
  </div>
);

CamPlaceholder.propTypes = {
  stillUrl: PropTypes.string,
  shouldLoad: PropTypes.bool,
};

export default CamPlaceholder;
